import React from 'react';

// Manifest (CSV/HTML) summary panel: header link, detected columns and the
// parsed manifest rows.
const ManifestPanel = ({
  scanMeta,
  manifestInfo,
  manifestRows,
  hasManifestCandidates,
}) => (
  <div className="mb-4 border border-hairline rounded-lg">
    <div className="p-3 border-b border-hairline flex items-center justify-between">
      <div className="text-sm font-semibold text-ink">
        Manifest
        {manifestInfo?.used ? (
          <span className="ml-2 text-xs font-normal text-muted">
            {String(manifestInfo.used.kind || 'manifest').toUpperCase()} · {Number(manifestInfo.row_count || manifestRows.length || 0)} rows
          </span>
        ) : null}
      </div>
      {manifestInfo?.used ? (
        <a
          href={manifestInfo.used.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-brand hover:underline break-all max-w-[60%] truncate"
          title={manifestInfo.used.label || manifestInfo.used.url}
        >
          {manifestInfo.used.label || manifestInfo.used.url}
        </a>
      ) : (hasManifestCandidates ? (
        <a
          href={manifestInfo.candidates[0].url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-brand hover:underline break-all max-w-[60%] truncate"
        >
          {manifestInfo.candidates[0].url}
        </a>
      ) : (
        <span className="text-xs text-muted">{scanMeta ? 'No manifest link' : 'No scan yet'}</span>
      ))}
    </div>
    {manifestInfo?.error ? (
      <div className="px-3 pt-2 text-xs text-amber-600 dark:text-amber-400">{manifestInfo.error}</div>
    ) : null}
    <div className="max-h-[260px] overflow-auto p-2 space-y-1">
      {(() => {
        // Render the detected column names above the parsed rows when
        // the backend surfaced an explicit header (CSV/XLSX, or an
        // HTML manifest table with <th> headers). Mirrors the Chrome
        // extension's "Columns (N): col1 | col2 | …" header row.
        const manifestColumns = Array.isArray(manifestInfo?.columns)
          ? manifestInfo.columns.filter((c) => typeof c === 'string' && c.trim().length > 0)
          : [];
        const hasHeaderColumns = manifestColumns.length > 0
          && manifestInfo && manifestInfo.has_header !== false;
        if (!hasHeaderColumns) return null;
        return (
          <div className="text-xs text-ink px-2 py-1 border-b border-hairline bg-surface-2 break-words">
            <span className="text-muted mr-1">Columns ({manifestColumns.length}):</span>
            <strong>{manifestColumns.join(' | ')}</strong>
          </div>
        );
      })()}
      {manifestRows.length === 0 ? (
        <div className="text-sm text-muted p-2">
          {!scanMeta
            ? 'No scan yet.'
            : (manifestInfo?.used ? 'No rows extracted.' : (hasManifestCandidates ? 'Manifest link found but not parsed.' : 'No manifest detected on this page.'))}
        </div>
      ) : manifestRows.map((row, index) => (
        <div key={`manifest-${index}`} className="text-xs text-ink px-2 py-1 border-b border-hairline last:border-b-0 break-words">
          {row.text}
          <span className={`ml-2 text-[10px] ${row.selected !== false ? 'text-positive' : 'text-amber-600 dark:text-amber-400'}`}>
            {row.selected !== false ? 'included' : 'excluded'}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default ManifestPanel;
